module.exports = __webpack_public_path__ + "media/images/icons/search-icon-bold-c67adf9edee8fd8bb08b2c05f7a4cf26.svg";